import {Container, Row, Col} from "reactstrap";
import "./HomePageOurSchool.css"
import REAL from "../../../../assets/RealEnglishImages/REAL.png"
const HomePageOurSchool=()=>{
    return(
        <section className="about-school-section py-5">
        <Container>
            <Row className="justify-content-center">
            <Col lg={8} className="text-center mb-5">
                <h2 className="display-5 fw-bold mb-3"> <Col xs={12} className="d-flex justify-content-center"> At  <img src={REAL} className="card-logo card-logo-dark ps-3" alt="logo dark" height="57"/></Col> English Academy</h2>
                <p className="lead">
                we believe English isn’t just something you study—it’s something you experience!
                </p>
            </Col>
            </Row>
            <Row className="g-4">
            {/* Interactive Learning */}
            <Col lg={4} className="text-center">
                <div className="about-card p-4">
                <i className="mdi mdi-brain fs-36 text-primary mb-3"></i>
                <h5 className="fw-bold">Interactive Learning</h5>
                <p>
                    Hands-on activities and games that make learning fun and natural.
                </p>
                </div>
            </Col>

            {/* Expert Instructors */}
            <Col lg={4} className="text-center">
                <div className="about-card p-4">
                <i className="mdi mdi-account-tie fs-36 text-success mb-3"></i>
                <h5 className="fw-bold">Expert Instructors</h5>
                <p>
                    Certified teachers with years of experience in language education.
                </p>
                </div>
            </Col>

            {/* Award-Winning Facilities */}
            <Col lg={4} className="text-center">
                <div className="about-card p-4">
                <i className="mdi mdi-trophy fs-36 text-warning mb-3"></i>
                <h5 className="fw-bold">Award-Winning Facilities</h5>
                <p>
                    Recognized for our innovative and vibrant learning spaces.
                </p>
                </div>
            </Col>
            </Row>
        </Container>
        </section>
    )
}
export default HomePageOurSchool;